// extracted by mini-css-extract-plugin
export default {"root":"root--qdNJE","body2":"body2--G2X5E"};